<template>
  <div class="system-card">
    <Card class="card-item" v-for="(item, index) in cardList" :key="index">
      <div class="card-main">
        <h1>{{item.platName}}</h1>
        <div class="actions">
          <Button size="small" type="primary" @click="toPlatPage(item)">主页</Button>
<!--          <Button v-if="item.admin" size="small">权限设置</Button>-->
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
  export default {
    name: 'SystemCard',
    props: {
      cardList: {
        type: Array,
        default: () => []
      }
    },
    methods: {
      toPlatPage (item) {
        window.open(item.url, '_blank')
      }
    }
  }
</script>

<style scoped lang="less">
  .system-card {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-content: center;
    .card-item {
      width: 320px;
      height: 130px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-content: center;
      &:not(first-child) {
        margin-left: 10px;
      }
      .card-main {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;
        text-align: center;
        .actions {
          display: flex;
          flex-direction: row;
          justify-content: space-around;
          align-content: center;
        }
      }
    }
  }
</style>
